import React from 'react';
import './SocialIcons.css';

export default function SocialIcons(){
  const facebookUrl = process.env.REACT_APP_FACEBOOK_URL || 'https://www.facebook.com/share/1DS8rMUijg/';
  const instagramUrl = process.env.REACT_APP_INSTAGRAM_URL || 'https://www.instagram.com/arya_homoeo_hall/';

  return (
    <div className="social-row" role="navigation" aria-label="Social links">
      <a
        className="social-btn"
        aria-label="Facebook"
        href={facebookUrl}
        target="_blank"
        rel="noreferrer"
      >
        <div className="social-item">
          <svg viewBox="0 0 320 512" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M279.14 288l14.22-92.66h-88.91V117.78c0-25.35 12.42-50.06 52.24-50.06H295V6.26S259.36 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.2V288z"/>
          </svg>
        </div>
      </a>

      <a
        className="social-btn"
        aria-label="Instagram"
        href={instagramUrl}
        target="_blank"
        rel="noreferrer"
      >
        <div className="social-item">
          <svg viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.9-26.9 26.9-14.9 0-26.9-12-26.9-26.9s12-26.9 26.9-26.9c14.9 0 26.9 12 26.9 26.9zm76.1 27.2c-1.7-35.7-9.9-67.2-36-93.2-26.1-26.1-57.6-34.3-93.2-36-37.1-2.1-148.4-2.1-185.5 0-35.7 1.7-67.2 9.9-93.2 36s-34.3 57.6-36 93.2c-2.1 37.1-2.1 148.4 0 185.5 1.7 35.7 9.9 67.2 36 93.2s57.6 34.3 93.2 36c37.1 2.1 148.4 2.1 185.5 0 35.7-1.7 67.2-9.9 93.2-36 26.1-26.1 34.3-57.6 36-93.2 2.1-37.1 2.1-148.4 0-185.5zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"/>
          </svg>
        </div>
      </a>
    </div>
  );
}
